import {ServiceBase} from "../ServiceBase";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {Drawer} from "./drawer-handler";
import {IDrawerService} from "./drawer.service.interface";
import {IOverlayConsumer} from "../overlay/overlay-consumer.interface";

export class DrawerService extends ServiceBase implements IDrawerService, IOverlayConsumer{

  left: Drawer;
  right: Drawer;

  constructor(serviceFactory: IServiceFactoryExtended) {
    super(serviceFactory);

    this.left = new Drawer(this.services);
    this.right = new Drawer(this.services);

    serviceFactory.overlay.registerConsumer(this);
    this.reaction(() => this.services.user.isAuthorized, isAuthorized => !isAuthorized && this._closeDrawers());
  }

  private _closeDrawers():void{
    this.left.closeDrawer();
    this.right.closeDrawer();
  }

  get needsOverlay(): boolean {
    return this.left.isOpen || this.right.isOpen
  }

  getOverlayZIndex(): number | undefined {
    return Math.max(this.left.getOverlayZIndex(), this.right.getOverlayZIndex())
  }
  onOverlayClicked(): void {
    this.left.onOverlayClicked();
    this.right.onOverlayClicked();
    this._closeDrawers();
  }

}
